import { Box, Button, Flex, FormControl, Image, Input, Stack, Text } from '@chakra-ui/react';
import logo from 'assets/ellure-logo.png';
import { useFormik } from 'formik';
import { useAuth } from '.';

export default function CompletePassword() {
  const { changePassword } = useAuth();
  const form = useFormik({
    initialValues: {
      email: '',
      password: '',
      password2: '',
    },
    onSubmit: async (values, helpers) => {
      try {
        await changePassword(values.password, values.email);
      } catch (e: any) {
        //helpers.setErrors(e.message);
      }
    },
  });

  return (
    <Box alignSelf='center' p={6} bg='white' w='100%' maxWidth='800px' borderColor='gray.200' borderWidth='1px'>
      <Flex flexDirection='column' alignItems='center' mx='14' pt='6' pb='2' justifyContent='space-between'>
        <Image src={logo} alt='Ellure Cloud Factory' width='100px' />
        <Text fontSize='sm'>Cloud Factory</Text>
        <form onSubmit={form.handleSubmit}>
          <Stack mt={6}>
            <FormControl>
              <Input
                placeholder='Email'
                id='email'
                name='email'
                type='email'
                variant='filled'
                onChange={form.handleChange}
                value={form.values.email}
              />
            </FormControl>
            <FormControl>
              <Input
                placeholder='New Password'
                id='password'
                name='password'
                type='password'
                variant='filled'
                onChange={form.handleChange}
                value={form.values.password}
              />
            </FormControl>
            <FormControl>
              <Input
                placeholder='Confirm Password'
                id='password2'
                name='password2'
                type='password'
                variant='filled'
                onChange={form.handleChange}
                value={form.values.password2}
              />
            </FormControl>
            <Button type='submit' colorScheme='blue'>
              Update password
            </Button>
          </Stack>
        </form>
      </Flex>
    </Box>
  );
}
